import API from '@aws-amplify/api';
import { createChatPost, updateChatPost, deleteChatPost,createNewChatPost,createSupportChatPost } from '../graphql/mutations';
import { getChatPostList, getChatPostDetail, getChatPostListPagination } from '../graphql/queries';
import Logger from '@/common/utils/Logger';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import I18n from '@/rI18n';
import { Storage } from 'aws-amplify';
import {
    getUserDeletedInfor,
    getUserListByIdList,
    getUserById
} from './userService';
import _ from 'lodash';
import APIAmplify from '@aws-amplify/api';
import { getExpressionQueryChatPostByChatThreadId } from './dynamoDBRequestDto/DynamoDBChatPostRequestDto';
import { getTicketDataGSI3WithFilter } from './ticketService';
import { AUTH_TYPE } from 'aws-appsync';
import { uploadFileToS3 } from '@/component/common/UploadFiles';
import { v4 as uuidv4 } from 'uuid';
import ApiGatewayConstant from '@/common/constant/ApiGatewayConstant';
import TelephoneConstant from '@/common/constant/TelephoneConstant';

/**
 * 
 * @param {*} APIClient 
 * @param {*} inputChatPost 
 * @returns 
 */
export const createNewChatPostFunction = async (APIClient, inputChatPost) => {
    let isSentMessage = inputChatPost.createNewChatPostRequestDto.isSentMessage || false;
    if (
        !inputChatPost ||
        !inputChatPost.createNewChatPostRequestDto ||
        Utils.isEmptyString(inputChatPost.createNewChatPostRequestDto.content) ||
        inputChatPost.createNewChatPostRequestDto.content.trim() === ''
    ) {
        return {};
    }

    try {
        let statusUpdateForTicket = inputChatPost?.createNewChatPostRequestDto?.statusUpdateForTicket;
        delete inputChatPost?.createNewChatPostRequestDto?.statusUpdateForTicket;

        if (inputChatPost?.createNewChatPostRequestDto.hasOwnProperty('isSentMessage')) {
            delete inputChatPost?.createNewChatPostRequestDto.isSentMessage;
        }

        const res = await APIAmplify.graphql({
            query: createChatPost,
            variables: {
                input: inputChatPost.createNewChatPostRequestDto
            }
        });
        
        APIAmplify.graphql({
            query: createNewChatPost,
            variables: {
                createNewChatPostRequestDto: {
                    postType: inputChatPost.createNewChatPostRequestDto.postType,
                    chatThreadId: inputChatPost.createNewChatPostRequestDto.chatThreadId,
                    content: inputChatPost.createNewChatPostRequestDto.content,
                    fileUrl: inputChatPost.createNewChatPostRequestDto?.fileUrl,
                    fileSize: inputChatPost.createNewChatPostRequestDto?.fileSize,
                    chatPostId: res.data.createChatPost.id,
                    creator: res.data.createChatPost.creatorId,
                    statusUpdateForTicket: statusUpdateForTicket,
                    isSentMessage: isSentMessage
                }
            }
        });
        return res.data.createChatPost;
    } catch (ex) {
        Logger.error('exception', ex);
    }
    return null;
};

export const handleSendAiAssistant = (inputChatPost, ticketDetail, setIdMessageRendering, isAiAssistantThread, projectInuseId, ticketId) => {
    let responseChatPostId = `post_${uuidv4()}`;
    let telephoneTicketId = ticketDetail.id;
    let isDesk = projectInuseId === ticketDetail.affiliationProject;
    const isVoiceCallProjectToProject =  Utils.defineVoiceCallFlow(ticketDetail?.metaData) === TelephoneConstant.VOICE_CALL_FLOW.PROJECT_TO_PROJECT
    if (isVoiceCallProjectToProject && !isAiAssistantThread) {
        console.log({isVoiceCallProjectToProject, parent: ticketDetail.parent, children: ticketDetail.children, id: ticketDetail.id})
        if (ticketDetail.parent) {
            telephoneTicketId = ticketDetail.parent
        } else {
            const childTicketId = Array.isArray(ticketDetail.children) ? ticketDetail.children[0] : (typeof children === 'string' ? ticketDetail.children.split(',')[0]?.trim() : '');          
            telephoneTicketId = childTicketId;
        }
    }

    // console.log({ticketId, ticketDetailId: ticketDetail.id})

    setIdMessageRendering(responseChatPostId);
    sendAiAssistantRequest({
        message: inputChatPost.content,
        aiAssistantChatThreadId: ticketDetail.aiAssistantChatThread,
        telephoneTicketId: telephoneTicketId,
        corporationId: ticketDetail.affiliationOrganization,
        projectId: ticketDetail.affiliationProject,
        userId: inputChatPost.creatorId,
        chatPostId: responseChatPostId,
        isAgentPrompt : isAiAssistantThread,
        isDesk: isDesk,
        isVoiceCallProjectToProject
    }).then(response => {
        console.log('response :>> ', response);
    }).catch((error) => {
        Logger.error('sendAiAssistantRequest error:', error);
    })
};

export const createNewChatPostWithFilesFunction = async (inputChatPost, otherParams) => {
    console.log('inputChatPost :>>---------------- ', inputChatPost);
    let isSentMessage = inputChatPost.createNewChatPostRequestDto.isSentMessage || false;
    if (
        !inputChatPost ||
        !inputChatPost.createNewChatPostRequestDto ||
        (Utils.isEmptyString(inputChatPost.createNewChatPostRequestDto.content.trim()) &&
            Utils.isEmptyArray(inputChatPost?.dataFiles?.uploadFiles))
    ) {
        return {};
    }

    try {
        let statusUpdateForTicket =
            inputChatPost?.createNewChatPostRequestDto?.statusUpdateForTicket;
        delete inputChatPost?.createNewChatPostRequestDto?.statusUpdateForTicket;

        if (inputChatPost?.createNewChatPostRequestDto.hasOwnProperty('isSentMessage')) {
            delete inputChatPost?.createNewChatPostRequestDto.isSentMessage;
        }

        const { corporationId, chatThreadId } = inputChatPost.createNewChatPostRequestDto;
        const { uploadFiles, userDetail, selectThread } = inputChatPost.dataFiles;

        const currentTime = new Date().getTime();

        let uploadError = false;

        if (!Utils.isEmptyArray(uploadFiles)) {
            for (const file of uploadFiles.map(i => i.fileData)) {
                const keyFileAtS3 = `${corporationId}/ticket/${selectThread.ticketId}/chatThread/${chatThreadId}/${userDetail?.id}/${currentTime}/${file.name}`;
                const fileUpload = { file, progress: 0, status: true, key: keyFileAtS3 };
                const result = await uploadFileToS3('setFileUploading', fileUpload);
                if (!result) {
                    uploadError = true;
                    break;
                }
            }
        }

        if (uploadError) {
            return;
        }

        const res = await APIAmplify.graphql({
            query: createChatPost,
            variables: {
                input: inputChatPost.createNewChatPostRequestDto
            }
        });

        console.log('otherParams', otherParams)

        if (otherParams?.isTriggerAssistantMessage) {
            handleSendAiAssistant(
                inputChatPost.createNewChatPostRequestDto,
                otherParams?.ticketInfo,
                otherParams?.setIdMessageRendering,
                otherParams?.isAiAssistantThread,
                otherParams?.projectInuseId
            );
        }

        const mappedFiles = uploadFiles.length
            ? uploadFiles.map(item => {
                  return {
                      fileUrl: `${corporationId}/ticket/${selectThread.ticketId}/chatThread/${chatThreadId}/${userDetail?.id}/${currentTime}/${item.fileData.name}`,
                      fileSize: item.fileData.size,
                      content: item.fileData.name
                  };
              })
            : [];

        APIAmplify.graphql({
            query: createNewChatPost,
            variables: {
                createNewChatPostRequestDto: {
                    postType: inputChatPost.createNewChatPostRequestDto.postType,
                    chatThreadId: inputChatPost.createNewChatPostRequestDto.chatThreadId,
                    content: inputChatPost.createNewChatPostRequestDto.content,
                    files: JSON.stringify(mappedFiles),
                    chatPostId: res.data.createChatPost.id,
                    creator: res.data.createChatPost.creatorId,
                    statusUpdateForTicket: statusUpdateForTicket,
                    isSentMessage: isSentMessage
                }
            }
        });
        return res.data.createChatPost;
    } catch (ex) {
        Logger.error('exception', ex);
    }
    return null;
};


export const getChatPostByPaging = async (APIClient, threadIds, from, projectInuse) => {
    try {
        const res = await API.graphql({
            query: getChatPostListPagination,
            variables: {
                params: {
                    chatThreadIdList: threadIds,
                    from: from,
                    size: Constant.CHAT_PAGINATION_DEFAULT_RECORD,
                    projectInuse: projectInuse
                }
            }
        });
       
        let listPostId  = []
        
        const dataList = res.data.getChatPostListPagination.data
       
        dataList?.forEach((item) => {
            if(item?.id){
                listPostId.push(item.id)
            }
        })
        if (Utils.isEmptyArray(res.data.getChatPostListPagination.data)) {
            return {
                data: [],
                from: from
            };
        }
        return {
            data: res.data.getChatPostListPagination.data.map(item => {
                return {
                    ...item,
                    attachFiles: Utils.convertJSONDataToObject(item?.attachFiles) || [],
                };
            }),
            from: res.data.getChatPostListPagination.from
        };

    } catch (error) {
        console.log('error-----------',error)
        return [];      
    }
}

export const getChatPostListByChatThreadId = async (APIClient, chatThreadIds, from, projectInUse) => {
    try {
        let chatPostAllList = [];
        let userIdChatList = [];
        
        let queryResult = await getChatPostByPaging(API, chatThreadIds, from, projectInUse);
        chatPostAllList = !Utils.isEmptyArray(queryResult.data) ? queryResult.data : [];

        let userIdChatByThread = getUserIdChatAndReadChatPostList(chatPostAllList);

        if (!Utils.isEmptyArray(userIdChatByThread)) {
            userIdChatList = [...new Set([...userIdChatList, ...userIdChatByThread])];
        }

        // get user infor : chat and footprint
        let userChatList = await getUserInforChatAndReadChatPostList(API, userIdChatList);
        // update user infor ( chat and footprint ) for msg
        const chatPostListResponse = await updateUserInforChatAndReadChatPostList(
            userChatList,
            chatPostAllList
        );
            
        // let responseData = {
        //     ...chatPostListResponse,
        //     ...{
        //         lastEvaluatedKey: queryResult.lastEvaluatedKey,
        //         count: queryResult.count,
        //     }
        // }

        return chatPostListResponse;
    } catch (ex) {
        Logger.error('getChatPostListByChatThreadId >>> exception: ', ex);
    }

    return null;
}

/**
 * 
 * @param {*} APIClient 
 * @param {*} chatThreadIdList 
 * @returns 
 */
export const getChatPostListByChatThreadIdList = async (APIClient, chatThreadIdList) => {
    if (
        typeof API === 'undefined' ||
        typeof chatThreadIdList === 'undefined' ||
        chatThreadIdList.length === 0
    ) {
        return null;
    }
    try {
        let chatPostAllList = [];
        let userIdChatList = [];
        chatThreadIdList = _.uniq(chatThreadIdList);
        chatThreadIdList = _.compact(chatThreadIdList);
        for (const element of chatThreadIdList) {
            const dynamodbParams = getExpressionQueryChatPostByChatThreadId(element, Constant.DEFAULT_LIMIT, 'ASC')
            const res = await API.graphql({
                query: getChatPostList,
                variables: {
                    params: {
                        expression: JSON.stringify(dynamodbParams)
                    }
                }
            });
            const listChatPost = !Utils.isEmptyArray(res.data.getChatPostList) ? res.data.getChatPostList : [];
            Logger.info('getChatPostListByChatThreadIdList >>> data: ', listChatPost);
            chatPostAllList = chatPostAllList.concat(listChatPost);
            // get user-id chat and footprint
            let userIdChatByThread = getUserIdChatAndReadChatPostList(
                listChatPost
            );
            if (!Utils.isEmptyArray(userIdChatByThread)) {
                userIdChatList = [...new Set([...userIdChatList, ...userIdChatByThread])];
            }
        }
        // get user infor : chat and footprint
        let userChatList = await getUserInforChatAndReadChatPostList(API, userIdChatList);
        // update user infor ( chat and footprint ) for msg
        const chatPostListResponse = await updateUserInforChatAndReadChatPostList(
            userChatList,
            chatPostAllList
        );
        return chatPostListResponse;

    } catch (ex) {
        Logger.error('getChatPostListByChatThreadIdList >>> exception: ', ex);
    }
    return null;
};

/**
 * 
 * @param {*} postDetail 
 * @returns 
 */
export const validatePostCreateAt = (postDetail) => {
    let result = {
        message: '',
        data: null,
    };
    try {
        if (Utils.isEmptyObject(postDetail)) {
            result.message = 'Chat-post is invalid!';
            return result;
        }
        if (postDetail.isDelegateThread && !postDetail.isPostCreatedAtCurrentTime) {
            if (Utils.isEmptyString(postDetail.ticketCreatedAt)) {
                result.message = I18n.get('USER07MSG002');
                return result;
            }
            if (Utils.isEmptyString(postDetail.postCreatedAtDateTime)) {
                result.message = I18n.get('USER07MSG002');
                return result;
            }
            // Validate format: YYYY/MM/DD HH:mm
            const regexDateTime = /^\d{4}\/(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01]) (2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/;
            if (!regexDateTime.test(postDetail.postCreatedAtDateTime)) {
                result.message = I18n.get('USER07MSG002');
                return result;
            }
            // Parse datetime string
            let dateTimeParts = postDetail.postCreatedAtDateTime.split(' ');
            let dateParts = dateTimeParts[0].split('/');
            let timeParts = dateTimeParts[1].split(':');

            let dateTimeCreatePost = new Date(
                +dateParts[0],
                +dateParts[1] - 1,
                +dateParts[2],
                +timeParts[0],
                +timeParts[1],
                0
            );
            
            // Validate if date is valid
            if (isNaN(dateTimeCreatePost.getTime())) {
                result.message = I18n.get('USER07MSG002');
                return result;
            }

            const ticketCreatedAt = new Date(postDetail.ticketCreatedAt);
            let dateTimeCreateTicket = new Date(
                ticketCreatedAt.getFullYear(),
                ticketCreatedAt.getMonth(),
                ticketCreatedAt.getDate(),
                ticketCreatedAt.getHours(),
                ticketCreatedAt.getMinutes(),
                0
            );
            if (dateTimeCreatePost < dateTimeCreateTicket || dateTimeCreatePost > new Date()) {
                result.message = I18n.get('USER07MSG002');
                return result;
            }
            result.data = dateTimeCreatePost.toISOString();
            return result;
        }
    } catch (error) {
        result.message = I18n.get('USER07MSG002');
        Logger.error('validatePostCreateAt exception', error);
    }
    return result;
};

/**
 * 
 * @param {*} userDetail 
 * @param {*} ticketInfo 
 * @param {*} selectThread 
 * @param {*} selectedProjectId 
 * @returns 
 */
export const checkPermissionChatPost = async (
    APIClient,
    userDetail,
    ticketInfo,
    selectThread,
    projectInuseDetail,
    isProjectManager,
    corporationDetail,
    panelType
) => {
    if (
        Utils.isEmptyObject(ticketInfo) ||
        Utils.isEmptyObject(userDetail) ||
        Utils.isEmptyObject(selectThread) ||
        Utils.isEmptyObject(projectInuseDetail) ||
        !Utils.isEmptyString(ticketInfo.deletedAt)
    ) {
        return false;
    }
    const selectedProjectId = projectInuseDetail.id;
    let enableChat = false;

    if(Utils.isDisabledTicketExternalWhenDeskServiceOff(ticketInfo, corporationDetail)) {
        return false;
    }

    if(ticketInfo?.anonymousQaStatus !== Constant.ANONYMOUS_TICKET_STATUS.CHAT_NOW && ticketInfo?.anonymousUserInfo?.type === Constant.ANONYMOUS_TYPE.CHATBOT_LIVECHAT) {
        return false;
    }

    //#1: QA, 2: Delegate, 3: Notice, 4: Escalation
    switch (ticketInfo.ticketType) {
        case Constant.TICKET_TYPE.INTERNAL_QA:
            enableChat = checkPermissionChatAtInternalQaTicket(
                userDetail,
                ticketInfo,
                selectThread,
                selectedProjectId
            );
            break;
        case Constant.TICKET_TYPE.QA:
        case Constant.TICKET_TYPE.EXTERNAL_QA:
            enableChat = checkPermissionChatAtTicketNormal(
                userDetail,
                ticketInfo,
                selectThread,
                projectInuseDetail,
            );
            break;
        case Constant.TICKET_TYPE.TELEPHONE:
            enableChat = checkPermissionChatAtTelephoneTicket(
                userDetail,
                ticketInfo,
                selectThread,
                projectInuseDetail,
            );
            break;
        case Constant.TICKET_TYPE.ESCALATION:
            enableChat = checkPermissionChatAtEscalationTicket(
                userDetail,
                ticketInfo,
                selectThread,
                selectedProjectId
            );
            break;
        case Constant.TICKET_TYPE.DELEGATE:
            enableChat = await checkPermissionChatAtTicketDelegate(
                userDetail,
                ticketInfo,
                selectThread,
                selectedProjectId,
            );
            break;
        case Constant.TICKET_TYPE.BROADCAST_CHILD:
        case Constant.TICKET_TYPE.BROADCAST_PARENT:
        case Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT:
        case Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT:
        case Constant.TICKET_TYPE.INVITATION_GUEST_CUSTOMER:
            enableChat = await checkPermissionChatAtTicketNotice(
                API,
                userDetail,
                ticketInfo,
                selectThread,
                selectedProjectId,
                panelType
            );
            break;
        
        case Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK:
            enableChat = checkPermissionChatAtTicketExternalDeskRequest(
                ticketInfo,
                selectThread,
                selectedProjectId,
                isProjectManager,
            );
            break;
        case Constant.TICKET_TYPE.TASK:
            enableChat = checkPermissionChatAtTicketTask(
                ticketInfo,
                selectThread,
                selectedProjectId
            );
            break;
        case Constant.TICKET_TYPE.EMAIL:
        case Constant.TICKET_TYPE.EMAIL_REPLY:
            enableChat = checkPermissionChatAtTicketEmail(
                ticketInfo,
                selectThread,
                selectedProjectId
            );
            break;
        default:
            break;
    }

    // check if org of ticket is blocked or delete
    if (
        selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER ||
        selectThread.threadType === Constant.THREAD_TYPE.ESCALATION ||
        selectThread.threadType === Constant.THREAD_TYPE.DELEGATE
    ) {
        enableChat =( ticketInfo.hasOneSideBlockedOrg || ticketInfo.hasOneSideDeletedOrg ) ? false : enableChat;
    }

    return enableChat;
};

/**
 * ticket: AQ, Escalation
 *
 * @param {*} userDetail
 * @param {*} ticketInfo
 * @param {*} selectThread
 * @param {*} selectedProjectId
 * @returns
 */
/**
 * Check permission chat at telephone ticket
 * Same as checkPermissionChatAtTicketNormal but also allows chat when user is at projectOrigin
 * (voice call cross-project: caller at BASE, ticket affiliationProject = DESK)
 */
const checkPermissionChatAtTelephoneTicket = (
    userDetail,
    ticketInfo,
    selectThread,
    projectInuseDetail,
) => {
    if (
        Utils.isEmptyObject(selectThread) ||
        Utils.isEmptyObject(userDetail) ||
        Utils.isEmptyObject(ticketInfo) ||
        !userDetail?.type
    ) {
        return false;
    }

    const selectedProjectId = projectInuseDetail.id;

    if (
        userDetail.type === Constant.USER_TYPE.CUSTOMER ||
        (Utils.isGuestUser(userDetail) && Utils.isProjectGuest(projectInuseDetail)) ||
        ticketInfo.customer === selectedProjectId
    ) {
        return selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER;
    }

    if (
        ticketInfo.projectTarget &&
        ticketInfo.projectTarget.includes(selectedProjectId)
    ) {
        return true;
    }
    if (ticketInfo.affiliationProject === selectedProjectId || ticketInfo.projectOrigin === selectedProjectId) {
        return true;
    }

    const ticketMetaData = Utils.convertJSONDataToObject(ticketInfo.metaData);
    if (
        ticketMetaData?.callType === TelephoneConstant.CALL_TYPE.VOICE_CALL &&
        Utils.getPrefixOfId(ticketMetaData?.to) === Constant.ID_PREFIX.USER &&
        projectInuseDetail.type === Constant.PROJECT_TYPE.BASE
    ) {
        // CASE prj -> user: projectOrigin, projectTarget = desk
        return true;
    }

    if (
        selectThread.threadType === Constant.THREAD_TYPE.ESCALATION &&
        ticketInfo.projectOrigin === selectedProjectId
    ) {
        return true;
    }
    return false;
};

const checkPermissionChatAtTicketNormal = (
    userDetail,
    ticketInfo,
    selectThread,
    projectInuseDetail,
) => {
    if (
        Utils.isEmptyObject(selectThread) ||
        Utils.isEmptyObject(userDetail) ||
        Utils.isEmptyObject(ticketInfo) ||
        !userDetail?.type
    ) {
        return false;
    }

    const selectedProjectId = projectInuseDetail.id;

    // user login is guest: only show customer-thread => guest user can post message
    if (
        userDetail.type === Constant.USER_TYPE.CUSTOMER ||
        (Utils.isGuestUser(userDetail) && Utils.isProjectGuest(projectInuseDetail)) ||
        ticketInfo.customer === selectedProjectId
    ) {
        return selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER;
    }

    // if user login is member of selected-project: read-only customer-thread, post message at all thread
    if (
        ticketInfo.projectTarget &&
        ticketInfo.projectTarget.includes(selectedProjectId)
    ) {
        return true;
    }
    if (
        selectThread.threadType === Constant.THREAD_TYPE.ESCALATION &&
        ticketInfo.projectOrigin === selectedProjectId
    ) {
        return true;
    }
    return false;
};

/**
 * 
 * @param {*} userDetail 
 * @param {*} ticketInfo 
 * @param {*} selectThread 
 * @param {*} selectedProjectId 
 * @returns 
 */
const checkPermissionChatAtTicketDelegate = async (
    userDetail,
    ticketInfo,
    selectThread,
    selectedProjectId,
) => {
    if (
        Utils.isEmptyObject(selectThread) ||
        Utils.isEmptyObject(userDetail) ||
        Utils.isEmptyObject(ticketInfo)
    ) {
        return false;
    }
    // user login is guest: only show customer-thread => guest user can post message
    if (userDetail.type === Constant.USER_TYPE.CUSTOMER) {
        return selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER;
    }

    if (
        selectThread.threadType === Constant.THREAD_TYPE.ESCALATION &&
        ticketInfo.projectOrigin === selectedProjectId
    ) {
        return true;
    }

    if (Utils.isGuestUser(userDetail) && ticketInfo.projectOrigin === selectedProjectId) {
        return selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER;
    }

    if ((Utils.isGeneralUserWithoutGuest(userDetail) || userDetail.type === Constant.USER_TYPE.INTERNAL) && ticketInfo.projectOrigin === selectedProjectId) {
        return selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER;
    }

    // All member in project Helpdesk can chat on all thread
    if (ticketInfo.projectTarget && ticketInfo.projectTarget.includes(selectedProjectId)) {
        return true;
        // if (selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER) {
        //     return true;
        // }
        // if (selectThread.threadType === Constant.THREAD_TYPE.INTERNAL) {
        //     return true;
        // }
    }

    return false;
};

/**
 * 
 * @param {*} APIClient 
 * @param {*} userDetail 
 * @param {*} ticketInfo 
 * @param {*} selectThread 
 * @param {*} selectedProjectId 
 * @returns 
 */
const checkPermissionChatAtTicketNotice = async(
    APIClient,
    userDetail,
    ticketInfo,
    selectThread,
    selectedProjectId,
    panelType
) => {
    if (Utils.isEmptyObject(selectThread) || Utils.isEmptyObject(ticketInfo) || panelType === Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD) {
        return false;
    }

    if (ticketInfo.affiliationProject !== selectedProjectId) {
        return false;
    }

    const editableRange = Utils.convertJSONDataToObject(selectThread.editableRange);
    if (
        (ticketInfo.customer === userDetail.id || ticketInfo.customer === selectedProjectId) &&
        editableRange[`${userDetail.affiliationOrganization}`]
    ) {
        const listTicketId =
            editableRange[`${userDetail.affiliationOrganization}`][`${selectedProjectId}`];
        if (!Utils.isEmptyArray(listTicketId)) {
            return listTicketId.includes(ticketInfo.id);
        }
    }

    if (
        ticketInfo.ticketType !== Constant.TICKET_TYPE.BROADCAST_CHILD &&
        ticketInfo.projectTarget &&
        ticketInfo.projectTarget.length === 1 &&
        ticketInfo.projectTarget.includes(selectedProjectId)
    ) {
        if (
            userDetail.type === Constant.USER_TYPE.CUSTOMER ||
            Utils.isGuestUser(userDetail)
        ) {
            return selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER;
        }
        return false;
    }

    if (ticketInfo.projectOrigin === selectedProjectId && ticketInfo.ticketType === Constant.TICKET_TYPE.BROADCAST_PARENT) {
        if(selectThread.threadType === Constant.THREAD_TYPE.INTERNAL) return true;

        let parentId =
        ticketInfo.ticketType === Constant.TICKET_TYPE.BROADCAST_PARENT
                ? ticketInfo.id
                : ticketInfo.parent;

        let customerNoticeData = await getTicketDataGSI3WithFilter(
            API,
            parentId,
            Constant.TICKET_DATA_TYPE.FIELD,
            Constant.TICKET_DATA_ID.CUSTOMER_NOTICE
        );

        if (!Utils.isEmptyArray(customerNoticeData)) {
            let customerNoticeDataValue = JSON.parse(customerNoticeData[0].dataValue).value;
            let prefixOfId = Utils.getPrefixOfId(customerNoticeDataValue);
            if (prefixOfId !== 'user' && prefixOfId !== 'project') {
                switch (customerNoticeDataValue) {
                    case 'AllCustomerProject':
                    case 'AllGuestCustomerUser':
                    case 'AllGeneralProject':
                    case 'AllUserInBaseProject':
                        return true;
                    default:
                        return false;
                }
            } else {
                return true;
            }
        }
    }

    // user login is member of selected-project: post message at all thread
    if (ticketInfo.projectOrigin === selectedProjectId) {
        return true;
    }
    // if user login is member of selected-project: read-only customer-thread, post message at internal-thread and escalation-thread
    if (
        ticketInfo.projectOrigin === selectedProjectId &&
        selectThread.threadType === Constant.THREAD_TYPE.INTERNAL
    ) {
        return true;
    }
    //
    if (
        selectThread.threadType === Constant.THREAD_TYPE.ESCALATION &&
        ticketInfo.projectOrigin === selectedProjectId
    ) {
        return true;
    }
    // Ticket INVITATION_GUEST_CUSTOMER
    if (ticketInfo.ticketType === Constant.TICKET_TYPE.INVITATION_GUEST_CUSTOMER &&
        selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER &&
        ticketInfo.customer === userDetail.id
    ) {
        return true;
    }

    return false;
};

/**
 * 
 * @param {*} userDetail 
 * @param {*} ticketInfo 
 * @param {*} selectThread 
 * @param {*} selectedProjectId 
 * @returns 
 */
const checkPermissionChatAtInternalQaTicket = (
    userDetail,
    ticketInfo,
    selectThread,
    selectedProjectId
) => {
    if (
        Utils.isEmptyObject(selectThread) ||
        Utils.isEmptyObject(ticketInfo) ||
        Utils.isEmptyObject(userDetail) ||
        !userDetail?.type
    ) {
        return false;
    }
    return (
        ticketInfo.projectOrigin === selectedProjectId ||
        ticketInfo.projectTarget.includes(selectedProjectId)
    );
};

/**
 * 
 * @param {*} userDetail 
 * @param {*} ticketInfo 
 * @param {*} selectThread 
 * @param {*} selectedProjectId 
 * @returns 
 */
const checkPermissionChatAtEscalationTicket = (
    userDetail,
    ticketInfo,
    selectThread,
    selectedProjectId,
) => {
    if (
        Utils.isEmptyObject(selectThread) ||
        Utils.isEmptyObject(ticketInfo) ||
        Utils.isEmptyObject(userDetail) ||
        !userDetail?.type
    ) {
        return false;
    }

    if (
        ticketInfo.ticketType === Constant.TICKET_TYPE.ESCALATION &&
        ticketInfo.deskService === Constant.STATUS_SERVICE_PERMISSION.OFF &&
        selectThread.threadType === Constant.THREAD_CHAT_TYPE.ESCALATION_THREAD
    ) {
        return false;
    }
    if(ticketInfo.projectOrigin === selectedProjectId) {
        return true;
    }

    if(ticketInfo.projectTarget.includes(selectedProjectId)) {
        // ticket escalation external => all project member can chat in customer thread
        // if(selectThread.threadType === Constant.THREAD_TYPE.ESCALATION && !listProjectInCorp.find(project => project.id === ticketInfo.projectOrigin)) {
        //     return true;
        // }

        return true;
    }

    return false;
};

const checkPermissionChatAtTicketExternalDeskRequest = (
    ticketInfo,
    selectThread,
    selectedProjectId,
    isProjectManager
) => {
    if (Utils.isEmptyObject(selectThread) || Utils.isEmptyObject(ticketInfo)) {
        return false;
    }

    // user login is member of target side(projectTarget): post message at all thread
    if (ticketInfo.projectTarget.includes(selectedProjectId)) {
        return true;
    }
    // if user login is PM of selected-project (projectOrigin): chat on customer-thread only
    if (
        ticketInfo.projectOrigin === selectedProjectId &&
        selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER
    ) {
        return true;
    }

    return false;
};

/**\
 * checkPermissionChatAtTicketTask
 * ticket task
 */
const checkPermissionChatAtTicketTask = (
    ticketInfo,
    selectThread,
    selectedProjectId
) => {
    if (Utils.isEmptyObject(selectThread) || Utils.isEmptyObject(ticketInfo)) {
        return false;
    }

    // if user login is PM of selected-project (projectOrigin): chat on customer-thread only
    if (
        ticketInfo.affiliationProject === selectedProjectId &&
        selectThread.threadType === Constant.THREAD_TYPE.INTERNAL
    ) {
        return true;
    }

    return false;
};

/**\
 * checkPermissionChatAtTicketEmail
 * ticket task
 */
export const checkPermissionChatAtTicketEmail = (
    ticketInfo,
    selectThread,
    selectedProjectId
) => {
    

    return true;
};

/**
 * 
 * @param {*} chatPostAllList 
 * @param {*} post 
 * @returns 
 */
export const getIndexChatPostMsg = (chatPostAllList, post, findById = false) => {
    if (Utils.isEmptyObject(post) || Utils.isEmptyArray(chatPostAllList)) {
        return -1;
    }
    if (findById) {
        let msgIndex = _.findIndex(chatPostAllList, function (p) {
            return p.id === post.id;
        });
        return msgIndex;
    }
    let msgIndex = _.findIndex(chatPostAllList, function (p) {
        return (
            p.creatorId === post.creatorId &&
            p.corporationId === post.corporationId &&
            p.chatThreadId === post.chatThreadId &&
            p.content === post.content &&
            (Utils.isEmptyString(p.id) || p.id === post.id) &&
            typeof p.insertFail === 'undefined'
        );
    });
    return msgIndex;
};


/**
 * Update chat post by id
 * @param {*} APIClient 
 * @param {*} chatPostInput 
 * @returns 
 */
export const updateChatPostById = async (APIClient, chatPostInput) => {
    try {
        let res = await API.graphql({
            query: updateChatPost,
            variables: {
                input: chatPostInput
            },
        });
        return res.data.updateChatPost;
    } catch (ex) {
        Logger.error('updateChatPostById error: ', ex);
        return null;
    }
};

/**
 * Delete chat post by id
 * @param {*} APIClient 
 * @param {*} id 
 * @returns chat post
 */
export const deleteChatPostById = async (APIClient, id) => {
    try {
        let res = await API.graphql({
            query: deleteChatPost,
            variables: {
                input: {
                    id: id
                }
            },
        });
        let chatPost = res.data.deleteChatPost;
        return chatPost;
    } catch (ex) {
        Logger.error('deleteChatPostById error: ', ex);
        return null;
    }
};

/**
 * Get chat post by id
 * @param {*} APIClient 
 * @param {*} id 
 * @returns chatPostDetail
 */
export const getChatPostById = async (APIClient, id) => {
    try {
        let res = await API.graphql({
            query: getChatPostDetail,
            variables: {
                params: { id: id }
            },
        });
        let chatPost = res.data.getChatPostDetail;
        if (!Utils.isEmptyObject(chatPost.footPrint) && !Utils.isEmptyArray(chatPost.footPrint.userList)) {
            chatPost.footprintListDetail = await getUserListByIdList(API, chatPost.footPrint.userList);
        }
        return chatPost;
    } catch (ex) {
        Logger.error('getChatPostById error: ', ex);
        return null;
    }
};

/**
 * 
 * @param {*} chatPostList 
 * @returns 
 */
const getUserIdChatAndReadChatPostList = (chatPostList) => {
    let userIdList = [];
    if (!Utils.isEmptyArray(chatPostList)) {
        chatPostList.forEach((post) => {
            if (!userIdList.includes(post.creatorId)) {
                userIdList.push(post.creatorId);
            }
            // footprint
            if (
                !Utils.isEmptyObject(post.footPrint) &&
                !Utils.isEmptyArray(post.footPrint.userList)
            ) {
                userIdList = [...new Set([...userIdList, ...post.footPrint.userList])];
                Logger.info('getUserIdChatAndReadChatPostList >>> userIdList', userIdList);
            }

            // mention
            if (!Utils.isEmptyArray(post.mention)) {
                userIdList = [...new Set([...userIdList, ...post.mention])];
                Logger.info('getUserIdChatAndReadChatPostList :>> mention :>> userIdList', userIdList);
            }
            
            // reaction
            let reaction = post.reaction ? Utils.convertJSONDataToObject(post.reaction) : {};
            if(!Utils.isEmptyObject(reaction)) {
                for (let key of Object.keys(reaction)) {
                    let listUserReaction = reaction[key].userId;
                    if(!Utils.isEmptyArray(listUserReaction)) {
                        userIdList = [...new Set([...userIdList, ...listUserReaction])];
                    }
                }
            }
        });
    }
    return userIdList;
};

/**
 * 
 * @param {*} APIClient 
 * @param {*} userIdList 
 * @returns 
 */
const getUserInforChatAndReadChatPostList = async (APIClient, userIdList) => {
    Logger.info('getUserInforChatAndReadChatPostList >>> userIdList', userIdList);
    let userInforList = [];
    if (!Utils.isEmptyArray(userIdList)) {
        let promiseList = [];
        let userIdCount = 0;
        let numUserQuery = 20;
        while (userIdCount < userIdList.length) {
            let userIdQueryList = userIdList.slice(userIdCount, userIdCount + numUserQuery);
            userIdQueryList.forEach(userId => {
                promiseList.push(getUserById(API, userId));
            });
            // promiseList.push(
            //     getUserListByIdList(API, userIdQueryList)
            // );
            Logger.info(
                'getUserInforChatAndReadChatPostList >>> userIdList.slice',
                userIdQueryList
            );
            userIdCount = userIdCount + numUserQuery;
        }
        // let chatPostAllNewList
        let userInforPromiseResponse = await Promise.all(promiseList).catch((err) => {
            Logger.error('getUserInforChatAndReadChatPostList >>> error: ', err);
        });

        userInforList = [...new Set([].concat(...userInforPromiseResponse))];
        Logger.info('getUserInforChatAndReadChatPostList >>> userInforList: ', userInforList);
    }
    return userInforList;
};



/**
 * Get user info chat post list
 * @param {*} userChatList 
 * @param {*} chatPost 
 * @returns userInfo
 */
const getUserInfoChatPostList = async (userChatList, chatPost) => {
    let message = { ...chatPost };
    let userDetailPostMsg = _.find(userChatList, function (p) {
        return p.id === message.creatorId;
    });
    if (!userDetailPostMsg) {
        userDetailPostMsg = getUserDeletedInfor(message.creatorId);
        userChatList.push(userDetailPostMsg);
    }
    // userDetailPostMsg.avatar = getUserAvatarUrl(userDetailPostMsg.image);
    if(userDetailPostMsg.image) {
        userDetailPostMsg.avatar = await Storage.get(userDetailPostMsg.image);
    } else {
        userDetailPostMsg.avatar = Constant.AVATAR_DEFAULT;
    }
    message.userDetailPostMsg = userDetailPostMsg;
    // footprint
    if (
        !Utils.isEmptyObject(chatPost.footPrint) &&
        !Utils.isEmptyArray(chatPost.footPrint.userList)
    ) {
        let userFootPrintList = _.filter(userChatList, function (user) {
            return chatPost.footPrint.userList.includes(user.id);
        });
        if (!userFootPrintList) {
            userFootPrintList = [];
        }
        message.footprintListDetail = userFootPrintList;
    } else {
        message.footprintListDetail = [];
    }
    return message;
};


/**
 * 
 * @param {*} userChatList 
 * @param {*} chatPostAllList 
 * @returns 
 */
const updateUserInforChatAndReadChatPostList = async (userChatList, chatPostAllList) => {
    if (!Utils.isEmptyArray(chatPostAllList)) {
        if (Utils.isEmptyArray(userChatList)) {
            userChatList = [];
        }
        userChatList = userChatList?.map(user => {
            if(user.active === Constant.ACTIVE_FLAG.DELETED) {
                let firstNameWithPrefix = `${Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, user?.firstName)} (${Constant.SUFFIX_TEXT.DELETED_USER})`;
                let firstName = {
                    jp: {
                        A: "F",
                        text: firstNameWithPrefix
                    }
                }

                let newMail = Constant.DELETED_USER_NAME;
                if (user.id === "assistant") {
                    newMail = 'assistant'
                }
                

                return {
                    ...user,
                    mail: newMail,
                    firstName: JSON.stringify(firstName),
                    middleName: "",
                    deleteFlag: 1,
                };
            }
            return user;
        });
        let chatPostListPromisesAll = chatPostAllList.map(chatPost => getUserInfoChatPostList(userChatList, chatPost));
        let chatPostAllNewList = await Promise.all(chatPostListPromisesAll);
        Logger.info('getChatPostListByChatThreadIdList >>> updateUserInforChatAndReadChatPostList >>> chatPostAllNewList:', chatPostAllNewList);
        const response = {
            chatPostAllList: chatPostAllNewList,
            userChatList
        };
        return response;
    }
    return {
        chatPostAllList: chatPostAllList,
        userChatList
    };
};


/**
 * 
 * @param {*} chatPostList 
 * @returns 
 */
export const sortByCreatedAtAndSeqAsc = (chatPostList) => {
    if (Utils.isEmptyArray(chatPostList)) {
        return [];
    }
    return chatPostList.sort((a, b) => {
        if(a?.deliverInfo?.status == Constant.DELIVER_STATUS.UNDELIVER && b?.deliverInfo?.status !== Constant.DELIVER_STATUS.UNDELIVER){
            return 1
        };

        if(a?.deliverInfo?.status != Constant.DELIVER_STATUS.UNDELIVER && b?.deliverInfo?.status == Constant.DELIVER_STATUS.UNDELIVER){
            return -1
        };
        let dateTimeForCompareA = a?.createdAt || a?.updatedAt;
        let dateTimeForCompareB = b?.createdAt || b?.updatedAt;

        if (dateTimeForCompareA) {
            dateTimeForCompareA = new Date(dateTimeForCompareA).getTime();
        }
        if (dateTimeForCompareB) {
            dateTimeForCompareB = new Date(dateTimeForCompareB).getTime();
        }

        if (dateTimeForCompareA === dateTimeForCompareB) {
            return (a?.seq || '').localeCompare(b?.seq || '');
        }
        return new Date(dateTimeForCompareA) - new Date(dateTimeForCompareB);
    });
}

export const sortByUpdatedAtAndSeqAsc = (chatPostList) => {
    if (Utils.isEmptyArray(chatPostList)) {
        return [];
    }
    return chatPostList.sort((a, b) => {
        if(a?.deliverInfo?.status == Constant.DELIVER_STATUS.UNDELIVER && b?.deliverInfo?.status !== Constant.DELIVER_STATUS.UNDELIVER){
            return 1
        };

        if(a?.deliverInfo?.status != Constant.DELIVER_STATUS.UNDELIVER && b?.deliverInfo?.status == Constant.DELIVER_STATUS.UNDELIVER){
            return -1
        };

        let dateTimeForCompareA = a?.updatedAt || a?.createdAt;
        let dateTimeForCompareB = b?.updatedAt || b?.createdAt;

        if (dateTimeForCompareA) {
            dateTimeForCompareA = new Date(dateTimeForCompareA).getTime();
        }
        if (dateTimeForCompareB) {
            dateTimeForCompareB = new Date(dateTimeForCompareB).getTime();
        }

        if (dateTimeForCompareA === dateTimeForCompareB) {
            return (a?.seq || '').localeCompare(b?.seq || '');
        }
        return new Date(dateTimeForCompareA) - new Date(dateTimeForCompareB);
    });
}

/**
 * 
 * @param {*} chatPostList 
 * @returns 
 */
 export const sortByDeliverAtAndSeqAsc = (chatPostList) => {
    if (Utils.isEmptyArray(chatPostList)) {
        return [];
    }
    return chatPostList.sort((a, b) => {
        if (a?.deliverInfo?.deliverAt === b?.deliverInfo?.deliverAt) {
            return (a?.seq || '').localeCompare(b?.seq || '');
        }
        if(Utils.isEmptyString(a?.deliverInfo?.deliverAt) || Utils.isEmptyString(b?.deliverInfo?.deliverAt)) {
            return -1;
        }
        return new Date(a?.deliverInfo?.deliverAt) - new Date(b?.deliverInfo?.deliverAt);
    });
}

/**
 * 
 * @param {*} chatPostList 
 * @returns 
 */
 export const sortByDisplayMessTimeAndSeqAsc = (chatPostList) => {
    if (Utils.isEmptyArray(chatPostList)) {
        return [];
    }
    return chatPostList.sort((a, b) => {
        if (a.displayMessTime === b.displayMessTime) {
            return (a?.seq || '').localeCompare(b?.seq || '');
        }
        return new Date(a.displayMessTime) - new Date(b.displayMessTime);
    });
}

/**
 * Update chat post by id
 * @param {*} APIClient 
 * @param {*} chatPostInput 
 * @returns 
 */
export const createChatPostAPI = async (APIClient, chatPostInput) => {
    try {
        let res = await API.graphql({
            query: createSupportChatPost,
            variables: {
                params: JSON.stringify(chatPostInput)
            },
            authMode: AUTH_TYPE.API_KEY
        });

        return res.data.createSupportChatPost;
    } catch (ex) {
        return {};
    }
};

export const deleteChatPortByIdAPI = async (APIClient, chatPostInput) => {
    try {
        let res = await API.graphql({
            query: createSupportChatPost,
            variables: {
                params: JSON.stringify(chatPostInput)
            },
            authMode: AUTH_TYPE.API_KEY
        });

        return res.data.createChatPost;
    } catch (ex) {
        return {};
    }
}

/**
 * Call API Gateway /ai/send-ai-assistant (sdautoApi - private, Cognito auth)
 * Amplify REST API tự động attach Cognito JWT token vào Authorization header
 * và xử lý CORS thông qua API Gateway configuration.
 *
 * @param {Object} params
 * @param {string} params.message - Nội dung tin nhắn gửi đến AI
 * @param {Object} [params.lastMessageData] - Dữ liệu tin nhắn cuối cùng
 * @param {string} params.aiAssistantChatThreadId - ID chat thread AI assistant
 * @param {Object} [params.aiAssistantChatThread] - Chat thread object (optional, Lambda sẽ tự query nếu không có)
 * @param {string} [params.aiAssistantTicketId] - ID ticket AI assistant
 * @param {string} params.telephoneTicketId - ID ticket telephone
 * @param {string} params.corporationId - ID tổ chức
 * @param {string} params.projectId - ID project
 * @param {string} params.userId - ID user hiện tại
 * @param {string} [params.chatPostId] - ID chat post (optional, dùng cho pre-generated ID)
 * @param {boolean} [params.isAgentPrompt ] - Flag agent prompt từ AI assistant thread
 * @returns {Promise<Object|null>} Response từ Lambda hoặc null nếu lỗi
 */
export const sendAiAssistantRequest = async (params) => {
    try {
        const response = await API.post('sdautoApi', ApiGatewayConstant.ASSISTANT_API_GATEWAY_PATH, {
            body: {
                message: params.message,
                lastMessageData: params.lastMessageData || null,
                aiAssistantChatThreadId: params.aiAssistantChatThreadId,
                aiAssistantChatThread: params.aiAssistantChatThread || null,
                aiAssistantTicketId: params.aiAssistantTicketId || null,
                telephoneTicketId: params.telephoneTicketId,
                corporationId: params.corporationId,
                projectId: params.projectId,
                userId: params.userId,
                chatPostId: params.chatPostId || null,
                isAgentPrompt : params.isAgentPrompt  || false,
                isDesk: params.isDesk || false,
                isVoiceCallProjectToProject: params.isVoiceCallProjectToProject || false,
            }
        });
        return response;
    } catch (error) {
        Logger.error('sendAiAssistantRequest error:', error);
        throw error;
    }
};
